import { call, put, takeLatest, select } from 'redux-saga/effects';
import pickBy from 'lodash/pickBy';
import { get } from 'lodash';
import apiCall from '../helpers/ApiCall';
import apiRoot from '../consts/apiRoot';
import { GET } from '../consts/Methods';
import { getSortParams } from '../helpers/utils';
import { FETCH_BUY_NOW_OFFERS, FETCH_BUY_NOW_OFFERS_FAIL, FETCH_BUY_NOW_OFFERS_SUCCESS } from '../redux/Offers';
import { BUY_NOW } from '../consts/navigation';
import { SET_LOADER } from '../redux/Loader';

function* getOffersFlow() {
  try {
    yield put(SET_LOADER({ value: true, }));
    const sortData = yield select((state) => get(state, ['tables', BUY_NOW, 'sort']));
    const queryValue = yield select((state) => get(state, ['tables', BUY_NOW, 'queryValue']));
    const limitValue = yield select((state) => get(state, ['tables', BUY_NOW, 'rowsPerPage']));
    const page = yield select((state) => get(state, ['tables', BUY_NOW, 'page']));
    const countries = yield select((state) => get(state, ['tables', BUY_NOW, 'countries']));
    const vehicleType = yield select((state) => state.vehicleType.vehicleType);

    const params = pickBy(
      {
        ...getSortParams(sortData),
        query: queryValue,
        limit: limitValue,
        page,
        countries: countries?.map((item) => (item.value)).join(','),
      },
      (val) => Boolean(val)
    );

    const endpoint = `${apiRoot}/${vehicleType}/offers/buy_now`;
    const offers = yield call(apiCall, { method: GET, endpoint, params, });
    yield put(FETCH_BUY_NOW_OFFERS_SUCCESS(offers));
  } catch (error) {
    yield put(FETCH_BUY_NOW_OFFERS_FAIL(error));
  } finally {
    yield put(SET_LOADER({ value: false, }));
  }
}

export default function* GetBuyNowOffers() {
  yield takeLatest(FETCH_BUY_NOW_OFFERS, getOffersFlow);
}
